import React, { useEffect, useState } from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from 'react-bootstrap';
import reactStringReplace from 'react-string-replace';
import * as Icons from 'react-feather';
import AddColor from './AddColor';
import EditColor from './EditColor';
import ViewColor from './ViewColor';
import DeleteColor from './DeleteColor';
import ColorModel from './models/ColorModel';
import { logAuditEvent } from '../../utils/auditLogger';

function ColorModal({ onClose, onSubmit, UserAction, show, selectedRow, moduleName = 'Color' }) {
  const [childData, setChildData] = useState(new ColorModel());
  const userAction = reactStringReplace(UserAction, 'User', () => '');

  useEffect(() => {
    if (show && selectedRow) {
      setChildData({ ...selectedRow });
    } else if (!show) {
      setChildData(new ColorModel());
    }
  }, [selectedRow, show]);

  const handleDataFromChild = (data) => {
    setChildData(data);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const actionDescriptor = UserAction === 'Delete' ? 'Delete Confirm' : 'Save';
    logAuditEvent(moduleName, `${UserAction || 'Action'} ${actionDescriptor}`, `${actionDescriptor} clicked`);
    onSubmit(e, childData);
  };

  const handleCancel = (label) => {
    logAuditEvent(moduleName, `${UserAction || 'Action'} ${label}`, `${label} clicked`);
    onClose();
  };

  const handleLoad = (data) => {
    setChildData(data);
  };

  let modalAction = null;
  let showButtons = null;

  if (UserAction === 'Add') {
    modalAction = <AddColor onLoad={handleLoad} sendDataToParent={handleDataFromChild} />;
    showButtons = (
      <div>
        <button className="btn btn-cancel me-2" name="Add" onClick={() => handleCancel('Cancel')}>
          Cancel
        </button>
        <button className="btn btn-submit" name="Add" onClick={handleSubmit}>
          Submit
        </button>
      </div>
    );
  } else if (UserAction === 'Edit') {
    modalAction = <EditColor ColorData={childData} sendDataToParent={handleDataFromChild} />;
    showButtons = (
      <div>
        <button className="btn btn-cancel me-2" name="Edit" onClick={() => handleCancel('Cancel')}>
          Cancel
        </button>
        <button className="btn btn-submit" name="Edit" onClick={handleSubmit}>
          Submit
        </button>
      </div>
    );
  } else if (UserAction === 'View') {
    modalAction = <ViewColor ColorData={selectedRow} />;
    showButtons = (
      <div>
        <button className="btn btn-cancel me-2" name="View" onClick={() => handleCancel('Close')}>
          Close
        </button>
      </div>
    );
  } else if (UserAction === 'Delete') {
    modalAction = <DeleteColor ColorData={selectedRow} />;
    showButtons = (
      <div>
        <button className="btn btn-sm btn-secondary m-1" name="Delete" onClick={() => handleCancel('Delete Cancel')}>
          Cancel
        </button>
        <button className="btn btn-sm btn-danger m-1" name="Delete" onClick={handleSubmit}>
          Delete
        </button>
      </div>
    );
  }

  if (UserAction === 'Delete') {
    return (
      <Modal show={show} onHide={() => handleCancel('Close')} backdrop="static">
        <ModalHeader className="alert custom-alert1 alert-danger modalheader-width">
          <ModalTitle>
            <div className="custom-alert-icon">
              <Icons.AlertOctagon className="flex-shrink-0" />
            </div>
            <div>{userAction} Color</div>
          </ModalTitle>
        </ModalHeader>
        <ModalBody>{modalAction}</ModalBody>
        <ModalFooter className="modalfooter-width">{showButtons}</ModalFooter>
      </Modal>
    );
  }

  return (
    <Modal show={show} onHide={() => handleCancel('Close')} backdrop="static">
      <ModalHeader className="modal-header border-0 custom-modal-header" closeButton>
        <ModalTitle>{userAction} Color</ModalTitle>
      </ModalHeader>
      <ModalBody>{modalAction}</ModalBody>
      <ModalFooter>{showButtons}</ModalFooter>
    </Modal>
  );
}

export default ColorModal;
